import axios from '@/libs/api.request'
// 获取批量信息
export const getExpense = (params) => {
  return axios.request({
    url: '/common/expenseItem',
    method: 'GET',
    params
  })
}
// 获取单个信息
export const getDetails = (id) => {
  return axios.request({
    url: `/common/expenseItem/${id}`,
    method: 'GET'
  })
}
// 删除单个信息
export const del = (id) => {
  return axios.request({
    url: `/common/expenseItem/${id}`,
    method: 'DELETE'
  })
}

// 修改单个信息
export const update = (data) => {
  return axios.request({
    url: `/common/expenseItem/${data.id}`,
    method: 'PUT',
    data
  })
}
// 新增单个信息
export const add = (data) => {
  return axios.request({
    url: '/common/expenseItem',
    method: 'POST',
    data
  })
}
